<div class="risk-breakdown-table-wrapper">
	<p-table
		data-cy="risk-breakdown-table"
		[value]="report?.dailyBreakdown ?? []"
		[paginator]="true"
		[rows]="20"
		[showCurrentPageReport]="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
		dataKey="businessDate"
		styleClass="dashboard-data-table"
	>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="businessDate">
					Date
					<p-sortIcon field="businessDate"></p-sortIcon>
				</th>

				<th pSortableColumn="highestSeverity">
					Severity
					<p-sortIcon field="highestSeverity"></p-sortIcon>
				</th>

				<th pSortableColumn="totalRiskValue">
					Risk
					<p-sortIcon field="totalRiskValue"></p-sortIcon>
				</th>

				<th class="action-column">
					Action
				</th>
			</tr>
		</ng-template>

		<ng-template let-day pTemplate="body">
			<tr>
				<td class="date-column">
					{{ formatBusinessDate(day.businessDate) }}
				</td>

				<td>
					<span
						class="risk-status"
						[ngClass]="getSeverityClass(day.highestSeverity)"
					>
						{{ day.highestSeverity || '—' }}
					</span>
				</td>

				<td class="risk-value">
					<span *ngIf="isFinancialReport()">
						{{ formatCurrency(day.totalRiskValue) }}
					</span>

					<span *ngIf="!isFinancialReport()">
						{{ formatOperationalRisks(day.operationsRiskCount) }}
					</span>
				</td>

				<td class="action-column">
					<button
						*ngIf="day.taskInstanceId !== null"
						type="button"
						class="risk-view-link"
						title="Open task in new tab"
						(click)="onViewTask(day)"
					>
						<span>View</span>
						<i class="pi pi-arrow-right"></i>
					</button>

					<span
						*ngIf="day.taskInstanceId === null"
						class="text-color-secondary"
					>
						—
					</span>
				</td>
			</tr>
		</ng-template>

		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="4">
					<div class="dashboard-empty-state">
						<i class="pi pi-check-circle"></i>
						<span>No risk breakdown available</span>
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
